/** Symbole der Wissens-Typen (V-13). */
import {
  BookOpen, FlaskConical, Film, GraduationCap, Headphones, Mic, MonitorPlay, Newspaper, Shapes, type LucideIcon,
} from 'lucide-react';

import type { WissensTyp } from '@/domain/types';

export const TYP_ICON: Record<WissensTyp, LucideIcon> = {
  buch: BookOpen,
  hoerbuch: Headphones,
  video: MonitorPlay,
  podcast: Mic,
  artikel: Newspaper,
  studie: FlaskConical,
  kurs: GraduationCap,
  doku: Film,
  sonstiges: Shapes,
};
